var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnlockedAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/lock-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.33268 12.8333V8.16667C9.33268 5.58934 11.422 3.5 13.9993 3.5C16.5767 3.5 18.666 5.58934 18.666 8.16667M13.9993 17.5V19.8333M6.99935 24.5H20.9994C22.288 24.5 23.3327 23.4553 23.3327 22.1667V15.1667C23.3327 13.878 22.288 12.8333 20.9994 12.8333H6.99935C5.71068 12.8333 4.66602 13.878 4.66602 15.1667V22.1667C4.66602 23.4553 5.71068 24.5 6.99935 24.5Z",
    stroke: "#FFB447",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlockedAlt);
export default __webpack_public_path__ + "static/media/icon-unlocked-alt.85a4032098c84b014ee2f193a291e153.svg";
export { ForwardRef as ReactComponent };